<template>
	<!-- 侧边栏 -->
	<div>  
		<el-row class="tac">
			<el-col :span="12">
				<el-menu
					default-active="2"
					class="el-menu-vertical-demo"
					background-color="#1F2D3D"
					text-color="#fff"
					active-text-color="#ffd04b">
					<el-submenu v-for="(secMenu, key) in menuData" :index="''+key+1+''">
						<template slot="title">
						<i class="iconfont" v-html="secMenu.icon"></i> 
						<!-- <i class="el-icon-menu"></i> -->
						<span>{{secMenu.title}}</span>
						</template>
						<el-menu-item v-for="(item, index) in secMenu.child" @click="routerChange(item)" :index="''+(key+1) + '-' + (index+1)+''"><i class="iconfont" v-html="item.icon"></i> {{item.title}}</el-menu-item>
					</el-submenu>
				<!-- <el-menu
				default-active="1"
				class="el-menu-vertical-demo"
				@open="handleOpen"
				@close="handleClose"
				background-color="#545c64"
				text-color="#fff"
				active-text-color="#ffd04b"
				>
					<div v-for="(secMenu, key) in menuData">
						<el-submenu :index="key+1+''">
							<template slot="title"><i class="el-icon-menu"></i><span>{{secMenu.title}}</span></template>
							<div v-for="(item, index) in secMenu.child">
								<el-menu-item  v-if="item.menu == menu" :index="(key+1) + '-' + (index+1)" @click="routerChange(item)">{{item.title}}</el-menu-item>
								<el-menu-item v-else index='' @click="routerChange(item)">{{item.title + (key+1) + '-' + (index+1)}}</el-menu-item>
							</div>
						</el-submenu>
					</div> -->
				</el-menu>
			</el-col>
		</el-row>
	</div>
</template>
<style type="text/css">
	.el-menu-vertical-demo i{
		color:#fff;
		font-size: 15px;
	}
	
</style>
<script>
	export default {
	  props: ['menuData', 'menu'],
	  data() {
	    return {
			isCollapse: true
	    }
	  },
	  methods: {
	    routerChange(item) 	{
	      // 与当前页面路由相等则刷新页面
	      if (item.url != this.$route.path) {
	        router.push(item.url)
	      } else {
	        _g.shallowRefresh(this.$route.name)
	      }
	    }
	  }
	}

</script>


// WEBPACK FOOTER //
// leftMenu.vue?15e31876